import React from 'react'
import Card from '../shared/card/card.jsx'

export default React.createClass({


  render: function() {
    let load;
    if (this.props.payAmt > 0) {
      if(this.props.paySubject === 'No history to display') {
        load =  <div>
                  <h3 className='brand-primary-color text-center'></h3>
                  <div className='text-center small' style={{lineHeight: '1.17'}}><small><br />{this.props.paySubject}</small></div>
                </div>
      }
      else {
        let payment = this.props.payAmt.toString()
        if(payment.length === 4) {
          payment += '0'
        }
        load =  <div>
                  <h3 className='brand-primary-color text-center'>${payment}</h3>
                <div className='text-center small' style={{lineHeight: '1.17'}}><small>charged on {this.props.payDate} for {this.props.paySubject}</small></div>
              </div>
      }
    }
    else{
      load = <div style={{textAlign: 'center'}}><img src='/common/latest/images/play/spinner.gif' alt='loading' className='pull-down-xs-2' style={{marginBottom: '5px'}} /></div>
    }

    return (
      <Card
        headerTitle={'Most Recent'}
        customHeaderStyle={{marginBottom: '10px'}}
        noPullDown>

        <div className='text-center'>Your last payment:</div>
       {load}
      </Card>
    )}
  })




// WEBPACK FOOTER //
// ./src/components/billing/billing-recent.jsx